const cards = [
  {
    title: '《暗夜追凶》——国产悬疑再攀高峰',
    desc: '层层反转的叙事结构，实力派演员倾情演绎，这部国产悬疑片让观众直呼过瘾，口碑持续走高。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20suspense%20thriller%20movie%20scene%20dark%20alley%20at%20night%20with%20detective%20figure%2C%20dramatic%20lighting%20noir%20style%2C%20warm%20red%20and%20gold%20color%20tones%2C%20cinematic%20film%20aesthetic%2C%20mysterious%20atmosphere%20with%20rain%20on%20street&width=800&height=600&seq=card-movie-01&orientation=landscape',
    tag: '悬疑',
  },
  {
    title: '《铁血战狼》热血回归，硬核动作燃炸银幕',
    desc: '全程高能的打斗场面，真实震撼的战争场景，国产动作片的新标杆，军事迷不可错过。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20military%20action%20movie%20scene%20soldiers%20in%20combat%20gear%2C%20explosive%20battlefield%20with%20dramatic%20lighting%2C%20heroic%20stance%2C%20warm%20gold%20and%20crimson%20color%20palette%2C%20cinematic%20epic%20composition&width=800&height=600&seq=card-movie-02&orientation=landscape',
    tag: '动作',
  },
  {
    title: '《云端之上》清新治愈，文艺佳作好评如潮',
    desc: '细腻的情感描绘，绝美的自然风光取景，这部文艺片用最温柔的方式讲述了一个关于成长的故事。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20artistic%20drama%20film%20scene%20mountain%20landscape%20with%20soft%20sunlight%2C%20poetic%20composition%2C%20warm%20natural%20colors%2C%20person%20standing%20on%20cliff%20edge%2C%20dreamy%20atmospheric%20lighting%2C%20gentle%20golden%20hour%20tones&width=800&height=600&seq=card-movie-03&orientation=landscape',
    tag: '文艺',
  },
  {
    title: '《笑傲江湖》喜剧天团集结，爆笑不断',
    desc: '顶级喜剧阵容强强联手，密集笑点搭配温情内核，今年最值得期待的国产喜剧大片。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20movie%20scene%20group%20of%20actors%20laughing%20in%20colorful%20costumes%2C%20bright%20festive%20atmosphere%2C%20traditional%20Chinese%20setting%20with%20red%20lanterns%2C%20warm%20golden%20lighting%2C%20joyful%20cinematic%20composition&width=800&height=600&seq=card-movie-04&orientation=landscape',
    tag: '喜剧',
  },
  {
    title: '《星海征途》国产科幻新纪元开启',
    desc: '震撼的视觉特效，宏大的宇宙世界观，国产科幻电影用实力证明我们也能拍出顶级科幻大片。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20scene%20spaceship%20in%20deep%20space%20with%20stars%2C%20futuristic%20cockpit%20design%2C%20dramatic%20lighting%20with%20warm%20gold%20accents%2C%20epic%20scale%20cinematic%20composition%2C%20nebula%20colors&width=800&height=600&seq=card-movie-05&orientation=landscape',
    tag: '科幻',
  },
  {
    title: '《长安十二夜》历史悬疑，匠心巨制',
    desc: '精良的服化道还原盛唐气象，烧脑的剧情让人欲罢不能，国产历史题材电影的又一力作。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20movie%20scene%20ancient%20Tang%20Dynasty%20palace%20at%20night%20with%20lanterns%2C%20traditional%20architecture%2C%20warm%20golden%20red%20color%20palette%2C%20mysterious%20atmosphere%2C%20period%20costume%20cinematic&width=800&height=600&seq=card-movie-06&orientation=landscape',
    tag: '历史',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
            精选推荐
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            编辑团队每日严选，为你推荐最值得一看的国产好片
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card) => (
            <article
              key={card.title}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="relative overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-48 md:h-52 object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 text-xs font-medium bg-primary-500 text-background-50 rounded-md">
                  {card.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {card.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}